import { SxProps, Theme } from "@mui/material";
import BaseButton from "./BaseButton";

export default function DangerBaseButton(props: {
  title: string;
  disabled?: boolean;
  loading?: boolean;
  type?: "submit" | "button" | "reset";
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  variant?: "text" | "outlined" | "contained";
  heigth?: number | string;
  sx?: SxProps<Theme>;
}) {
  const {
    title,
    disabled,
    loading,
    type,
    onClick,
    startIcon,
    endIcon,
    variant,
    heigth,
    sx,
  } = props;

  return (
    <BaseButton
      sx={{
        borderColor: "#ff6060",
        color: "#ff6060",
        "& .MuiTypography-root": {
          color: "#ff6060",
        },
        "& .MuiSvgIcon-root": {
          color: "#ff6060",
          width: "20px",
          height: "20px",
        },
        border:
          variant === "outlined" ? "1px solid #ff6060" : "1px solid #ff6060",
        width: "fit-content",
        height: heigth || "auto",
        "&:hover": {
          borderColor: "#ff6060",
          backgroundColor: variant === "outlined" ? "transparent" : "#ff6060",
          color: variant === "outlined" ? "#ff6060" : "#FFFFFF",
          "& .MuiTypography-root": {
            color: variant === "outlined" ? "#FFFFFF" : "#FFFFFF",
          },
          "& .MuiSvgIcon-root": {
            color: variant === "outlined" ? "#FFFFFF" : "#FFFFFF",
          },
        },
        ...(sx || {}),
      }}
      title={title}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      type={type}
      startIcon={startIcon}
      endIcon={endIcon}
      variant={variant ?? "outlined"}
    />
  );
}
